import classNames from 'classnames';

import styles from './EmptyState.module.scss';
import { EmptyStateIcon } from './EmptyStateIcon';

type EmptyStateProps = {
  title?: string;
  subtitle?: string;
  hasBorder?: boolean;
};

export const EmptyState = ({
  title = 'No Data Available',
  subtitle = 'There is currently no data to display. Please check back later or adjust your filters.',
  hasBorder = false,
}: EmptyStateProps) => {
  return (
    <div
      className={classNames(styles.emptyStateContainer, {
        [styles.hasBorder]: hasBorder,
      })}
    >
      <div className={styles.emptyStateContent}>
        <div className={styles.emptyStateIcon}>
          <EmptyStateIcon />
        </div>
        <div className={styles.emptyStateTexts}>
          <div className={styles.emptyStateTitle}>{title}</div>
          <div className={styles.emptyStateSubtitle}>{subtitle}</div>
        </div>
        <div>Contact your Account Manager to get started.</div>
      </div>
    </div>
  );
};
